import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../core/services/auth.service';
import { ApiService } from '../../../core/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-to-fav',
  imports: [CommonModule],
  templateUrl: './add-to-fav.html',
  styleUrl: './add-to-fav.scss',
})
export class AddToFav {
  @Input() itemId!: string;
  @Input() _id!: string;
  @Input() set initialFavorite(value: boolean) {
    this.isFavorite = !!value;
  }

  showLoginPopup = false;
  isFavorite = false;
  isLoading = false;

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private toastr: ToastrService,
  ) { }

  onFavoriteClick(event: Event): void {
    event.stopPropagation();

    console.log('❤️ Favorite button clicked for item:', this.itemId);
    const isAuth = this.authService.isAuthenticated();
    console.log('🔍 Is authenticated?', isAuth);

    if (!isAuth) {
      console.log('⚠️ User not authenticated - showing error message');
      this.toastr.error('يجب تسجيل الدخول لإضافة العقارات إلى المفضلة', 'تسجيل الدخول مطلوب');
      // this.showLoginPopup = true; // Kept commented out as requested
      return;
    }

    console.log('✅ User authenticated - toggling favorite');
    this.toggleFavorite();
  }

  private toggleFavorite(): void {
    if (this.isLoading) return;

    console.log('🔄 Toggling favorite for item:', this.itemId);
    this.isLoading = true;
    const request$ = this.isFavorite
      ? this.apiService.delete(`/favorites/${this.itemId}`)
      : this.apiService.post('/favorites', { item: this.itemId });

    console.log(
      this.isFavorite
        ? `📤 Sending DELETE request to: /favorites/${this.itemId}`
        : `📤 Sending POST request to: /favorites with body: ${JSON.stringify({ item: this.itemId })}`,
    );

    request$.subscribe({
      next: (response) => {
        console.log('✅ Favorite toggled successfully:', response);
        this.isFavorite = !this.isFavorite;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('❌ Error toggling favorite:', error);
        this.isLoading = false;
      },
    });
  }

  closeLoginPopup(): void {
    this.showLoginPopup = false;
  }
}
